export const MONDAY = 0x01
export const TUESDAY = 0x02
export const WEDNESDAY = 0x04
export const THURSDAY = 0x08
export const FRIDAY = 0x10
export const SATURDAY = 0x20
export const SUNDAY = 0x40
